import { Space } from 'antd';
import GridPhotos from 'components/commons/GridPhotos';
import { ORDER_FAILQC_REASONS } from 'constants/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';

const FailQCInformation = ({ data }: { data: DynamicObjectType }) => {
  const { t } = useTranslation();
  return (
    <Space size={10} className="align-items-start" direction="vertical">
      <div>
        <div className="fw-600">{t('orders.cancelReason')}</div>
        <div>
          {t(
            ORDER_FAILQC_REASONS.find((i) => i?.value === data?.failQCReason)
              ?.text || '',
          )}
        </div>
      </div>
      <div>
        <div className="fw-600">{t('orders.note')}</div>
        <div>{data?.failQCNote}</div>
      </div>
      <div>
        <div className="fw-600">{t('ordersReturn.image')}</div>
        <div className="flex flex-wrap gap-2.5 mt-1">
          <GridPhotos
            images={data?.failQCImages}
            width={80}
            maxPreview={5}
            className="!mr-[5px]"
          />
        </div>
      </div>
    </Space>
  );
};

export default FailQCInformation;
